module.exports = __webpack_public_path__ + "img/icon-document-litigio.fa706510.svg";